module.exports = __webpack_public_path__ + "media/images/mypage/mypage_t1-263698367dfc815bf4629940889fe2ca.gif";